module.exports = __webpack_public_path__ + "static/media/135_ExteriorBackstairs.dee3f943.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135_ExteriorBackstairs.jpg
// module id = 527
// module chunks = 0